import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";

export const BANNER_TYPES = {
  promotion: { label: "Promotion", bg: "#FEF3C7", fg: "#92400E" },
  fermeture: { label: "Fermeture", bg: "#FEE2E2", fg: "#991B1B" },
  voeux: { label: "Vœux", bg: "#E8F5EE", fg: "#076633" },
  info: { label: "Information", bg: "#E0F2FE", fg: "#075985" },
};

export function EmailBannerBlock({ c, set }) {
  const t = BANNER_TYPES[c.email_banner_type] || BANNER_TYPES.voeux;
  return (
    <div className="rounded-xl border bg-white p-6 space-y-4" data-testid="email-banner-block">
      <div className="flex items-start justify-between gap-3">
        <div><h3 className="font-head font-semibold">Bannière e-mail saisonnière</h3>
          <p className="text-sm text-slate-500">Court message ajouté sous la signature de tous les e-mails (promotion, fermeture, vœux…).</p></div>
        <Switch checked={!!c.email_banner_actif} onCheckedChange={(v) => set("email_banner_actif", v)} data-testid="email-banner-active" />
      </div>
      <div className="flex flex-wrap gap-2">{Object.entries(BANNER_TYPES).map(([k, v]) => (
        <button key={k} type="button" onClick={() => set("email_banner_type", k)} data-testid={`email-banner-type-${k}`}
          className={`rounded-full px-3 py-1 text-xs font-medium border transition-colors ${(c.email_banner_type || "voeux") === k ? "border-slate-800" : "border-transparent"}`}
          style={{ background: v.bg, color: v.fg }}>{v.label}</button>))}</div>
      <div><Label className="text-xs">Message (300 caractères max)</Label>
        <Textarea rows={2} maxLength={300} value={c.email_banner_texte || ""} onChange={(e) => set("email_banner_texte", e.target.value)} className="mt-1" placeholder="Ex. : Toute l'équipe OMNIBAT vous souhaite de belles fêtes de fin d'année !" data-testid="email-banner-text" /></div>
      <div className="grid grid-cols-2 gap-3">
        <div><Label className="text-xs">Afficher à partir du (facultatif)</Label><Input type="date" value={c.email_banner_debut || ""} onChange={(e) => set("email_banner_debut", e.target.value)} className="mt-1" data-testid="email-banner-start" /></div>
        <div><Label className="text-xs">Jusqu'au (facultatif)</Label><Input type="date" value={c.email_banner_fin || ""} onChange={(e) => set("email_banner_fin", e.target.value)} className="mt-1" data-testid="email-banner-end" /></div>
      </div>
      {c.email_banner_texte && <div><p className="text-xs text-slate-400 mb-1">Aperçu</p>
        <div className="rounded-lg px-4 py-3 text-sm text-center max-w-[560px]" style={{ background: t.bg, color: t.fg }} data-testid="email-banner-preview">{c.email_banner_texte}</div></div>}
      <p className="text-xs text-slate-500">Pensez à cliquer sur « Enregistrer » pour appliquer la bannière.</p>
    </div>
  );
}
